import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import config from 'config'
import Icon from 'srcReact/components/icons/Icon'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import { redirectToBack } from 'srcReact/helpers/history'
import styles from './styles.module.scss'
// import GDPRCookieConsent from 'srcReact/GDPRCookieConsent'
import { isUserAuthorized } from 'srcReact/helpers/userHelper'
import { isEmpty } from 'srcReact/helpers/validator'
import CloseAccountModal from 'srcReact/Settings/components/CloseAccountModal'
import { urlSearchParams } from 'srcReact/helpers/utils'
import SelectOrganization from './components/SelectOrganization'
import CloseAccForOrgManagerModal from 'srcReact/Settings/components/CloseAccForOrgManagerModal'
import { isOrganizationManager } from 'srcReact/helpers/organizationHelper'
import { settingsActions } from 'srcReact/Settings/action'
import BackNavigation from 'srcReact/components/common2/BackNavigation'

export default function PrivacyPolicy() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [isGDPRModalOpen, setIsGDPRModalOpen] = useState(false)
  const [showRequestToDeleteModal, setShowRequestToDeleteModal] = useState(false)
  const [showSelectOrgModal, setShowSelectOrgModal] = useState(false)
  const [selectedOrg, setSelectedOrg] = useState(null)
  const [showCloseAccForOrgManager, setShowCloseAccForOrgManager] = useState(false)
  const {
    common: { isNative, isMobile, enableGDPRCookie },
    organization: { organization_list, current_organization }
  } = useSelector((state) => state)
  const [isLogged, setIsLogged] = useState(false)

  useEffect(() => {
    if (isUserAuthorized()) {
      setIsLogged(true)
      const element = document.querySelector('#request_to_delete')
      if (element) {
        element.addEventListener('click', handleRequestToDelete)
      }
      return () => {
        if (element) {
          element.removeEventListener('click', handleRequestToDelete)
        }
      }
    } else {
      setIsLogged(false)
    }
  }, [])

  const deleteAccount = (organization) => {
    if (isOrganizationManager(organization)) {
      setShowSelectOrgModal(false)
      setShowCloseAccForOrgManager(true)
    } else {
      dispatch(settingsActions.requestDeleteAccount(organization.id))
    }
  }

  const handleRequestToDelete = () => {
    if (!isEmpty(organization_list)) {
      if (organization_list.items.length === 1) {
        setShowRequestToDeleteModal(true)
        if (isNative && urlSearchParams('current_organization')) {
          const currentOrg = JSON.parse(urlSearchParams('current_organization'))
          if (currentOrg) {
            setSelectedOrg(currentOrg)
          }
        } else {
          setSelectedOrg(current_organization)
        }
      } else {
        setShowSelectOrgModal(true)
      }
    }
  }

  const hideRequestToDeleteModal = () => {
    setShowRequestToDeleteModal(false)
  }
  const hideSelectOrgModal = () => {
    setShowSelectOrgModal(false)
  }
  const hideCloseAccForOrgManager = () => {
    setShowCloseAccForOrgManager(false)
  }

  const openGDPRModal = () => {
    setIsGDPRModalOpen(true)
  }

  const closeGDPRModal = () => {
    setIsGDPRModalOpen(false)
  }

  return (
    <PageContainer pageTitle={t('privacy_policy.title')} withFooter={false}>
      <div className={styles.privacyWrapper}>
        <div className={styles.headerWrapper}>
          <img
            src={`${config.assetUrl + '/images/background-default-mixr.jpeg'}`}
            alt={t('privacy_policy.main_title')}
          />
          <BackNavigation theme='white' className={styles.back} customHandleBack={() => redirectToBack(false)} />

          <h2 className={styles.mainTitle}>{t('privacy_policy.main_title')}</h2>
          <p className={styles.mainDesc}>{t('privacy_policy.main_desc')}</p>
        </div>
        <div className={styles.contentWrapper}>
          <p className={styles.subDesc} dangerouslySetInnerHTML={{ __html: t('privacy_policy.sub_desc_1_1') }}></p>
          <p className={styles.subDesc}>{t('privacy_policy.sub_desc_1_2')}</p>
          <p className={styles.subDesc}>{t('privacy_policy.sub_desc_1_3')}</p>
          <p className={styles.subDesc}>{t('privacy_policy.sub_desc_1_4')}</p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('privacy_policy.sub_heading_1')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('privacy_policy.sub_desc_2_1')}</p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('privacy_policy.sub_heading_2')}</h2>
          <ul className={styles.listHead}>
            <li className={styles.list}>{t('privacy_policy.sub_list_2_1')}</li>
            <li className={styles.list}>{t('privacy_policy.sub_list_2_2')}</li>
            <li className={styles.list}>{t('privacy_policy.sub_list_2_3')}</li>
            <li className={styles.list}>{t('privacy_policy.sub_list_2_4')}</li>
            <li className={styles.list}>{t('privacy_policy.sub_list_2_5')}</li>
            <li className={styles.list}>{t('privacy_policy.sub_list_2_6')}</li>
            <li className={styles.list}>{t('privacy_policy.sub_list_2_7')}</li>
            <li className={styles.list}>{t('privacy_policy.sub_list_2_8')}</li>
            <li className={styles.list}>{t('privacy_policy.sub_list_2_9')}</li>
          </ul>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('privacy_policy.sub_heading_3')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('privacy_policy.sub_desc_3_1')}</p>
          <p
            className={`${styles.subDesc} ${styles.white}`}
            dangerouslySetInnerHTML={{ __html: t('privacy_policy.sub_desc_3_2') }}></p>
          <p
            className={`${styles.subDesc} ${styles.white}`}
            dangerouslySetInnerHTML={{ __html: t('privacy_policy.sub_desc_3_3') }}></p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('privacy_policy.sub_heading_4')}</h2>
          <p className={styles.subDesc}>{t('privacy_policy.sub_desc_4_1')}</p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('privacy_policy.sub_heading_5')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('privacy_policy.sub_desc_5_1')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('privacy_policy.sub_desc_5_2')}</p>
          <p
            className={`${styles.subDesc} ${styles.white}`}
            dangerouslySetInnerHTML={{ __html: t('privacy_policy.sub_desc_5_3') }}></p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('privacy_policy.sub_heading_6')}</h2>
          <p className={styles.subDesc}>{t('privacy_policy.sub_desc_6_1')}</p>
          <p className={styles.subDesc}>{t('privacy_policy.sub_desc_6_2')}</p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('privacy_policy.sub_heading_7')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('privacy_policy.sub_desc_7_1')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('privacy_policy.sub_desc_7_2')}</p>
          <p
            className={`${styles.subDesc} ${styles.white}`}
            dangerouslySetInnerHTML={{ __html: t('privacy_policy.sub_desc_7_3') }}></p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('privacy_policy.sub_heading_8')}</h2>
          <p className={styles.subDesc}>{t('privacy_policy.sub_desc_8_1')}</p>
          <p className={styles.subDesc}>{t('privacy_policy.sub_desc_8_2')}</p>
          <p className={styles.subDesc}>
            {t('privacy_policy.sub_desc_8_3_1')}
            <button onClick={openGDPRModal} className={styles.cookieSetting}>
              {t('privacy_policy.sub_desc_8_3_2')}
            </button>
          </p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('privacy_policy.sub_heading_9')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('privacy_policy.sub_desc_9_1')}</p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('privacy_policy.sub_heading_10')}</h2>
          <p className={styles.subDesc}>{t('privacy_policy.sub_desc_10_1')}</p>
          <p className={styles.subDesc}>{t('privacy_policy.sub_desc_10_2')}</p>
          <p className={styles.subDesc} dangerouslySetInnerHTML={{ __html: t('privacy_policy.sub_desc_10_3') }}></p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('privacy_policy.sub_heading_11')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('privacy_policy.sub_desc_11_1')}</p>
          <ul className={styles.listHead}>
            <li className={`${styles.list} ${styles.white}`}>{t('privacy_policy.sub_list_11_1')}</li>
            <li className={`${styles.list} ${styles.white}`}>{t('privacy_policy.sub_list_11_2')}</li>
            <li className={`${styles.list} ${styles.white}`}>{t('privacy_policy.sub_list_11_3')}</li>
            <li className={`${styles.list} ${styles.white}`}>{t('privacy_policy.sub_list_11_4')}</li>
            <li className={`${styles.list} ${styles.white}`}>{t('privacy_policy.sub_list_11_5')}</li>
            <li className={`${styles.list} ${styles.white}`}>{t('privacy_policy.sub_list_11_6')}</li>
          </ul>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('privacy_policy.sub_heading_12')}</h2>
          <p className={styles.subDesc}>{t('privacy_policy.sub_desc_12_1')}</p>
          <p className={styles.subDesc}>{t('privacy_policy.sub_desc_12_2')}</p>
          <p className={styles.subDesc}>{t('privacy_policy.sub_desc_12_3')}</p>
          <p className={styles.subDesc}>{t('privacy_policy.sub_desc_12_4')}</p>
          <p className={styles.subDesc}>{t('privacy_policy.sub_desc_12_5')}</p>
          <p className={styles.subDesc}>{t('privacy_policy.sub_desc_12_6')}</p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('privacy_policy.sub_heading_13')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('privacy_policy.sub_desc_13_1')}</p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('privacy_policy.sub_heading_14')}</h2>
          <p className={styles.subDesc}>{t('privacy_policy.sub_desc_14_1')}</p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('privacy_policy.sub_heading_15')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('privacy_policy.sub_desc_15_1')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('privacy_policy.sub_desc_15_2')}</p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('privacy_policy.sub_heading_16')}</h2>
          <p className={styles.subDesc}>{t('privacy_policy.sub_desc_16_1')}</p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('privacy_policy.sub_heading_17')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('privacy_policy.sub_desc_17_1')}</p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('privacy_policy.sub_heading_18')}</h2>
          <p className={styles.subDesc}>{t('privacy_policy.sub_desc_18_1')}</p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('privacy_policy.sub_heading_19')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('privacy_policy.sub_desc_19_1')}</p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('privacy_policy.sub_heading_20')}</h2>
          <p className={styles.subDesc} dangerouslySetInnerHTML={{ __html: t('privacy_policy.sub_desc_20_1') }} />
          <p className={`${styles.subDesc} ${styles.subDescWithList}`}>{t('privacy_policy.sub_desc_20_2')}</p>
          <ul className={styles.listHead}>
            <li className={styles.list}>{t('privacy_policy.sub_list_20_1')}</li>
            <li className={styles.list}>{t('privacy_policy.sub_list_20_2')}</li>
            <li className={styles.list}>{t('privacy_policy.sub_list_20_3')}</li>
            <li className={styles.list}>{t('privacy_policy.sub_list_20_4')}</li>
          </ul>

          <p
            className={`${styles.subDesc} ${isLogged ? styles.loggedUser : styles.loggedOutUser}`}
            dangerouslySetInnerHTML={{
              __html:
                isMobile || isNative ? t('privacy_policy.sub_desc_20_3_mobile') : t('privacy_policy.sub_desc_20_3')
            }}
          />
        </div>
      </div>
      {/* {(!isNative || (isNative && enableGDPRCookie == 1)) && (
        <GDPRCookieConsent isOpen={isGDPRModalOpen} screen='setting' closeGDPRModal={closeGDPRModal} />
      )} */}
      {showRequestToDeleteModal && (
        <CloseAccountModal
          orgName={selectedOrg && (selectedOrg.name || selectedOrg.info.name)}
          showModal={showRequestToDeleteModal}
          modalType='delete'
          hideModal={hideRequestToDeleteModal}
        />
      )}
      {showSelectOrgModal && (
        <SelectOrganization
          showModal={showSelectOrgModal}
          hideModal={hideSelectOrgModal}
          deleteAccount={deleteAccount}
        />
      )}
      {showCloseAccForOrgManager && (
        <CloseAccForOrgManagerModal
          showModal={showCloseAccForOrgManager}
          hideModal={hideCloseAccForOrgManager}
          closeAccType='delete'
          isNative={isNative}
        />
      )}
    </PageContainer>
  )
}
